import React, { Component } from 'react';
import autoBind from 'react-autobind';
import TaskNews from 'src/components/misc/task-news';
import OperatorNotificationList from 'src/components/nav/components/operator-notification-list';
import { Entities, fetchAllCustomRepository, getEntities, OPERATOR_NOTIFICATIONS_TYPE } from 'src/common';
import { connect } from 'react-redux';
import CircularProgress from 'material-ui/CircularProgress';
import { HardwareKeyboardArrowDown } from 'material-ui/svg-icons';

export const NOTIFICATION_MENU_TYPES = Object.freeze({
    TASK: 'TASK',
    NOTIFICATION: 'NOTIFICATION',
    NEWSLETTER: 'NEWSLETTER',
});

class OperatorNotificationsModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            activeType: this.props.openMenu != null ? this.props.openMenu : NOTIFICATION_MENU_TYPES.TASK,
            hoveredType: null,
        };
    }

    componentWillMount() {
        this.props.fetchAllCustomRepository(Entities.ALL_OPERATOR_NOTIFICATIONS, 'getAllNotifications');
    }

    render() {
        const { activeType } = this.state;
        const { t, allNotifications } = this.props;
        if (allNotifications.isFetching) return <CircularProgress />;

        const { silentAndPopupNotifications, newsletterNotifications } = allNotifications.items.reduce(
            (acc, notification) => {
                if (notification.type === OPERATOR_NOTIFICATIONS_TYPE.NEWSLETTER) {
                    acc.newsletterNotifications.push(notification);
                } else if (
                    notification.type === OPERATOR_NOTIFICATIONS_TYPE.SILENT ||
                    notification.type === OPERATOR_NOTIFICATIONS_TYPE.POPUP
                ) {
                    acc.silentAndPopupNotifications.push(notification);
                }
                return acc;
            },
            { silentAndPopupNotifications: [], newsletterNotifications: [] },
        );

        return (
            <>
                <div className="row" style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                    {this.renderMenuItem(t('booked_tasks.booked_tasks'), NOTIFICATION_MENU_TYPES.TASK)}
                    {this.renderMenuItem(
                        t('operator_notifications.modal.recent_notifications'),
                        NOTIFICATION_MENU_TYPES.NOTIFICATION,
                    )}
                    {this.renderMenuItem(
                        t('operator_notifications.modal.newsletter'),
                        NOTIFICATION_MENU_TYPES.NEWSLETTER,
                    )}
                </div>
                <div className="col-md-12 bf-operator-notification-content">
                    {activeType === NOTIFICATION_MENU_TYPES.TASK && (
                        <div>
                            <TaskNews t={t} />
                        </div>
                    )}
                    {activeType === NOTIFICATION_MENU_TYPES.NOTIFICATION && (
                        <div>
                            <OperatorNotificationList
                                t={t}
                                notifications={silentAndPopupNotifications}
                                title={t('operator_notifications.modal.recent_notifications')}
                            />
                        </div>
                    )}
                    {activeType === NOTIFICATION_MENU_TYPES.NEWSLETTER && (
                        <div>
                            <OperatorNotificationList
                                t={t}
                                notifications={newsletterNotifications}
                                title={t('operator_notifications.modal.newsletter')}
                            />
                        </div>
                    )}
                </div>
            </>
        );
    }

    renderMenuItem(title, type) {
        const isActive = this.state.activeType === type;
        return (
            <div
                className="col-md-4"
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}
                onClick={() => this.setState({ activeType: type })}>
                <div className={`col-md-12 bf-notification-menu-item ${isActive ? 'is-active' : ''}`}>{title}</div>

                {isActive && (
                    <div className="bf-is-active-icon">
                        <HardwareKeyboardArrowDown color="#333" />
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        allNotifications: getEntities(state, Entities.ALL_OPERATOR_NOTIFICATIONS),
    };
};

export default connect(mapStateToProps, {
    fetchAllCustomRepository,
})(OperatorNotificationsModal);
